// Hook odpowiedzialny za dodanie produktu do listy zakupowej typu (np. FAVORITES)

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

interface IRequest {
  productId: number;
  unitId: number;
  quantity: number;
  type: string;
}

type IResponse = ICommandResponseSuccess;

const postShoppingListTypeAddProduct = (data: IRequest): Promise<IResponse> =>
  axios.post('/shopping-lists/types/add-product', data);

export const usePostShoppingListTypeAddProduct = (
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => postShoppingListTypeAddProduct(data), options);
